module.exports = __webpack_public_path__ + "static/media/b1.05c5d886.png";